import { defineAsyncComponent } from 'vue';

const IdfIconCheck = defineAsyncComponent(() => import('./check/check.vue.mjs'));
const IdfIconCheckCircleFilled = defineAsyncComponent(() => import('./check/check-circle-filled.vue.mjs'));
const IdfIconCheckCircleOutlined = defineAsyncComponent(() => import('./check/check-circle-outlined.vue.mjs'));
const IdfIconExclamationTriangleFilled = defineAsyncComponent(
  () => import('./exclamation/exclamation-triangle-filled.vue.mjs')
);
const IdfIconExclamationTriangleOutlined = defineAsyncComponent(
  () => import('./exclamation/exclamation-triangle-outlined.vue.mjs')
);
const IdfIconHandThumbDownFilled = defineAsyncComponent(() => import('./hand-thumb/hand-thumb-down-filled.vue.mjs'));
const IdfIconHandThumbDownOutlined = defineAsyncComponent(
  () => import('./hand-thumb/hand-thumb-down-outlined.vue.mjs')
);
const IdfIconHandThumbUpFilled = defineAsyncComponent(() => import('./hand-thumb/hand-thumb-up-filled.vue.mjs'));
const IdfIconHandThumbUpOutlined = defineAsyncComponent(() => import('./hand-thumb/hand-thumb-up-outlined.vue.mjs'));
const IdfIconHourglassBottomCircleFilled = defineAsyncComponent(
  () => import('./hourglass/hourglass-bottom-circle-filled.vue.mjs')
);
const IdfIconHourglassSlash = defineAsyncComponent(() => import('./hourglass/hourglass-slash.vue.mjs'));
const IdfIconHourglassSlashCircleFilled = defineAsyncComponent(
  () => import('./hourglass/hourglass-slash-circle-filled.vue.mjs')
);
const IdfIconHourglassSlashCircleOutlined = defineAsyncComponent(
  () => import('./hourglass/hourglass-slash-circle-outlined.vue.mjs')
);
const IdfIconHourglassTop = defineAsyncComponent(() => import('./hourglass/hourglass-top.vue.mjs'));
const IdfIconHourglassTopCircleOutlined = defineAsyncComponent(
  () => import('./hourglass/hourglass-top-circle-outlined.vue.mjs')
);
const IdfIconInfoCircleFilled = defineAsyncComponent(() => import('./info/info-circle-filled.vue.mjs'));
const IdfIconInfoCircleOutlined = defineAsyncComponent(() => import('./info/info-circle-outlined.vue.mjs'));
const IdfIconInprogressCircleFilled = defineAsyncComponent(
  () => import('./inprogress/inprogress-circle-filled.vue.mjs')
);
const IdfIconInprogressCircleOutlined = defineAsyncComponent(
  () => import('./inprogress/inprogress-circle-outlined.vue.mjs')
);
const IdfIconInprogress = defineAsyncComponent(() => import('./inprogress/inprogress.vue.mjs'));
const IdfIconRetry = defineAsyncComponent(() => import('./retry/retry.vue.mjs'));
const IdfIconStar = defineAsyncComponent(() => import('./star/star.vue.mjs'));
const IdfIconStarFilled = defineAsyncComponent(() => import('./star/star-filled.vue.mjs'));
const IdfIconStarHalf = defineAsyncComponent(() => import('./star/star-half.vue.mjs'));
const IdfIconTruckCircleFilled = defineAsyncComponent(() => import('./truck/truck-circle-filled.vue.mjs'));
const IdfIconTruckCircleOutlined = defineAsyncComponent(() => import('./truck/truck-circle-outlined.vue.mjs'));
const IdfIconXCircleFilled = defineAsyncComponent(() => import('./x/x-circle-filled.vue.mjs'));
const IdfIconXCircleOutlined = defineAsyncComponent(() => import('./x/x-circle-outlined.vue.mjs'));
const IdfIconPaused = defineAsyncComponent(() => import('./paused/paused.vue.mjs'));

export { IdfIconCheck, IdfIconCheckCircleFilled, IdfIconCheckCircleOutlined, IdfIconExclamationTriangleFilled, IdfIconExclamationTriangleOutlined, IdfIconHandThumbDownFilled, IdfIconHandThumbDownOutlined, IdfIconHandThumbUpFilled, IdfIconHandThumbUpOutlined, IdfIconHourglassBottomCircleFilled, IdfIconHourglassSlash, IdfIconHourglassSlashCircleFilled, IdfIconHourglassSlashCircleOutlined, IdfIconHourglassTop, IdfIconHourglassTopCircleOutlined, IdfIconInfoCircleFilled, IdfIconInfoCircleOutlined, IdfIconInprogress, IdfIconInprogressCircleFilled, IdfIconInprogressCircleOutlined, IdfIconPaused, IdfIconRetry, IdfIconStar, IdfIconStarFilled, IdfIconStarHalf, IdfIconTruckCircleFilled, IdfIconTruckCircleOutlined, IdfIconXCircleFilled, IdfIconXCircleOutlined };
